import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const SearchableMultiSelect = ({
  label,
  searchLabel,
  searchPlaceholder,
  options,
  value,
  onChange,
  getOptionValue,
  getOptionLabel,
  helperText,
}) => {
  const selectedOptions = useMemo(() => {
    const selectedIds = new Set((value || []).map((id) => String(id)));
    return (options || []).filter((option) => selectedIds.has(String(getOptionValue(option))));
  }, [options, value, getOptionValue]);

  const handleChange = (_, newValue) => {
    const ids = (newValue || []).map((option) => {
      const rawValue = getOptionValue(option);
      const numericValue = Number(rawValue);
      return Number.isNaN(numericValue) ? rawValue : numericValue;
    });

    onChange(ids);
  };

  return (
    <div>
      <Autocomplete
        multiple
        options={options || []}
        value={selectedOptions}
        onChange={handleChange}
        disableCloseOnSelect
        filterSelectedOptions={false}
        noOptionsText="Sin resultados"
        getOptionLabel={(option) => getOptionLabel(option) || ""}
        isOptionEqualToValue={(option, selected) =>
          String(getOptionValue(option)) === String(getOptionValue(selected))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={searchPlaceholder || searchLabel}
            size="small"
            variant="outlined"
          />
        )}
      />
      {helperText && <p style={{ fontSize: 12, color: "#666", margin: "4px 0 0" }}>{helperText}</p>}
    </div>
  );
};

SearchableMultiSelect.propTypes = {
  label: PropTypes.string,
  searchLabel: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  getOptionValue: PropTypes.func,
  getOptionLabel: PropTypes.func,
  helperText: PropTypes.string,
};

SearchableMultiSelect.defaultProps = {
  label: "Seleccionar",
  searchLabel: "Buscar",
  searchPlaceholder: "",
  options: [],
  value: [],
  onChange: (f) => f,
  getOptionValue: (option) => option.id,
  getOptionLabel: (option) => option.nombre,
  helperText: "",
};

export default SearchableMultiSelect;
